/**
 * @version GENERATOR_VERSION::20200504
 * @DateTime 2020-07-08T19:32:01.8
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'rentmanage-conversionrent-'

export default {
    path: '/rentmanage/conversionrent',
    name: 'rentmanage-conversionrent',
    redirect: {
        name: '${pre}-index'
    },

    meta: {
        ...meta,
    },

    component: BasicLayout,
    children: [{
            path: 'index',
            name: '${pre}conversionrent-index',

            meta: {
                ...meta,
                title: '转租管理'
            },

            component: () => import('@/pages/rentmanage/conversionrent/index'),
        },
        {
            path: 'detail-edit/:id',
            name: '${pre}conversionrent-detail-edit',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '转租管理编辑'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-edit'),
        },
        {
            path: 'detail-edit',
            name: '${pre}conversionrentdetail-create',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '转租管理新增'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-edit'),
        },
        {
            path: 'detail-view/:id',
            name: '${pre}conversionrentView',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '转租管理详情查看'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-view'),
        },
    ]
};
